export const USER_ROLES = {
  ADMIN: 'admin',
  EDITOR: 'editor',
  VIEWER: 'viewer',
  CONSULTANT: 'consultant',
  CONSULTANT_ADMIN: 'consultant_admin',
  AUDITOR: 'auditor',
  MDM_EDITOR: 'mdm_editor',
  SUPPLIER: 'supplier',
} as const

export const ASSIGNABLE_EMPLOYEE_ROLES = [
  USER_ROLES.VIEWER,
  USER_ROLES.EDITOR,
  USER_ROLES.AUDITOR,
  USER_ROLES.MDM_EDITOR,
  USER_ROLES.SUPPLIER,
] as const

export const AUDITOR_RETENTION_DAYS = 30
